module.exports = __webpack_public_path__ + "img/to_shop_kr.247261a9.png";